import { ICountry, IHierarchyAPIQuery, HierarchyLevelType } from 'common/interfaces/hierarchy-entities';
import {
  HierarchyEntityName, getHierarchyEntitiesAPICallAction, getHierarchyEntityAPICallAction, postHierarchyEntityAPICallAction, putHierarchyEntityAPICallAction,
  deleteHierarchyEntityAPICallAction,
} from '../helpers/hierarchy-api-actions-factory';
import { createHierarchyEntitySlice } from '../../hierarchy-state-slice-factory';

const slice = createHierarchyEntitySlice<ICountry>(HierarchyLevelType.Country);

export const {
  itemsRequested: countriesRequested,
  itemsRecieved: countriesRecieved,
  itemsFailed: countriesFailed,
  itemRecieved: countryRecieved,
  itemDeleteRecieved: countriesDeleteRecieved,
} = slice.actions;

export default slice.reducer;

export const getCountries = (params: Partial<IHierarchyAPIQuery>) => getHierarchyEntitiesAPICallAction(HierarchyEntityName.COUNTRY, params, countriesRequested.type, countriesFailed.type, countriesRecieved.type);

export const getCountry = (entityId: string, parentId: string) => getHierarchyEntityAPICallAction(HierarchyEntityName.COUNTRY, { entityId, parentId }, countriesRequested.type, countriesFailed.type, countryRecieved.type);

export const createCountry = (data: Partial<ICountry>) => postHierarchyEntityAPICallAction(HierarchyEntityName.COUNTRY, data, countriesRequested.type, countriesFailed.type, countryRecieved.type);

export const updateCountry = (data: any) => putHierarchyEntityAPICallAction(HierarchyEntityName.COUNTRY, data.countryid, data, countriesRequested.type, countriesFailed.type, countryRecieved.type);

export const deleteCountry = (data: Partial<ICountry>) => deleteHierarchyEntityAPICallAction(HierarchyEntityName.COUNTRY, data.countryid!, countriesRequested.type, countriesFailed.type, countriesDeleteRecieved.type);
